import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Businesses = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('reveal-show');
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal-card, .reveal-text').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const categories = [
    { name: "Technology & Consulting", color: "blue", companies: [
      { name: "AALITECH", desc: "Leading technology solutions provider specializing in digital transformation and enterprise software", link: "/companies/aalitech" },
      { name: "AALI CONSSULTANCY", desc: "Employment and education consultancy connecting job seekers with opportunities in India and overseas, and students with the right institutions", link: "/companies/aaliconssultancy" }
    ]},
    { name: "Infrastructure & Development", color: "orange", companies: [
      { name: "AALI BUILDERS", desc: "Premier infrastructure development company building world-class residential and commercial projects", link: "/companies/aalibuilders" }
    ]},
    { name: "Media & Entertainment", color: "red", companies: [
      { name: "AALI MOVIES", desc: "Film production house creating compelling cinema that entertains and inspires audiences worldwide", link: "/companies/aalimovies" },
      { name: "AALI FILMZ", desc: "Digital content studio specializing in web series, short films, and digital entertainment", link: "/companies/aalifilmz" },
      { name: "AALI MUSIC", desc: "Music label and production company promoting diverse artists and creating chart-topping hits", link: "/companies/aalimusic" }
    ]},
    { name: "Luxury & Retail", color: "gold", companies: [
      { name: "AALI GOLD JEWELZ", desc: "Premium jewelry brand offering exquisite designs crafted with the finest materials", link: "/companies/aaligoldjewelz" }
    ]},
    { name: "Social Impact", color: "green", companies: [
      { name: "AALI TRUSTZ", desc: "Charitable foundation dedicated to education, healthcare, and community development initiatives", link: "/companies/aalitrustz" }
    ]}
  ];

  return (
    <>
      <div className="business-hero">
        <div className="hero-content">
          <h1 className="hero-title reveal-text">Our Businesses</h1>
          <p className="hero-subtitle reveal-text delay-1">A diversified portfolio of companies creating value across five dynamic industries</p>
        </div>
      </div>
      <div className="business-wrapper">
        <div className="container">
          {categories.map((cat, idx) => (
            <div key={idx} className="category">
              <div className={`category-header ${cat.color}`}>
                <h2>{cat.name}</h2>
                <p>Innovative solutions and strategic consulting services</p>
              </div>
              <div className="card-grid">
                {cat.companies.map((company, cidx) => (
                  <div key={cidx} className={`business-card ${cat.color} reveal-card`} style={{ animationDelay: `${cidx * 0.1}s` }}>
                    <h3>{company.name}</h3>
                    <p>{company.desc}</p>
                    <Link to={company.link}>Know More →</Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Businesses;